// extracted by mini-css-extract-plugin
export var loadingSpinner = "_61-1";
export var standaloneTable = "_61-0";